import { object, number, string } from 'yup';
import HttpStatus from 'http-status-codes';

export const SchemaError = {
  [HttpStatus.BAD_REQUEST]: {
    bedroomsCount: 'Invalid request'
  }
};

export default object().shape({
  googlePlaceID: string()
    .required('Please select your building address')
    .typeError('Please select your building address'),
  property: object()
    .shape({
      propertyID: number().required('Please select your building address'),
      address: string().required('Please select your building address')
    })
    .typeError('Please select your building address')
    .nullable(),
  buildingName: string().when('property', {
    is: val => val && val.buildingsNames && val.buildingsNames.length > 0,
    then: object()
      .shape({
        label: string(),
        value: string().required('Please select building name')
      })
      .required('Please select building name')
      .typeError('Please select building name')
  }),
  unitNumber: string()
    .required('Please enter unit number')
    .min(1, 'Please enter unit number'),
  bedroomsCount: object()
    .shape({
      label: string(),
      value: string().required('Please select number of bedrooms')
    })
    .required('Please select number of bedrooms')
    .typeError('Please select number of bedrooms')
});
